define('boxes/changePasswordBox',['jquery', 'boxes/box', 'boxes/events/loginEvent', 'boxes/helpers/loginHelper', 'all/comeon'], function ($, box, loginEvent, loginHelper, comeon) {
    'use strict';

    var loginDoneCallback = function () {
    };

    function init(changePasswordBox) {

        // Used server-side-empty flow ChangePwForm to open dialog changePW.jsp, flow ChangePassword goes to UpdatePW

		setupEnterHandler(changePasswordBox.$box.find('form'));

		if(changePasswordBox.model.tempPassLoginData) {
			changePasswordBox.$box.find('#change-pw-temp-login').show();
			changePasswordBox.$box.find('#change-pw-forget-pw').hide();
		} else {
			changePasswordBox.$box.find('#change-pw-temp-login').hide();
			changePasswordBox.$box.find('#change-pw-forget-pw').show();
		}

        changePasswordBox.model.shouldVerify = false;

        changePasswordBox.$controller.on(loginEvent.CHANGE_PASSWORD, function (event, loginData) {
            event.preventDefault();
            //changePasswordBox.model.shouldVerify = true;
            changePasswordBox.model.userName = loginData.uName;
			changePasswordBox.model.tempPassLoginData = loginData;
        });

        changePasswordBox.$controller.on(loginEvent.SET_LOGIN_DONE_CALLBACK, function (event, loginDoneCallbackRef) {
            event.preventDefault();
            loginDoneCallback = loginDoneCallbackRef;
        });

        changePasswordBox.$box.find('a.send-button').click(function (event) {
            event.preventDefault();

            if (changePasswordBox.$box.find('form').valid() === false) {
                return;
            }

            var newPassword = changePasswordBox.$box.find('input[name=PARAM_PASSWORD]').filter(':visible').val();
            var confirmNewPassword = changePasswordBox.$box.find('input[name=PARAM_PASSWORD_CONFIRMATION]').filter(':visible').val();
			if(changePasswordBox.model.tempPassLoginData) {
				var uName = changePasswordBox.model.tempPassLoginData.uName;
				var tempPass = changePasswordBox.model.tempPassLoginData.tempPass;

				$.post('/pp?flow=ChangePassword', {PARAM_PASSWORD: newPassword, PARAM_PASSWORD_CONFIRMATION: confirmNewPassword, PARAM_PASSWORD_OLD: tempPass}, function (data) {
					changePasswordSuccess(changePasswordBox, data);
				});

			} else {
				var email = changePasswordBox.model.email;
				var code = changePasswordBox.model.code;

				$.post('/pp?flow=ChangePasswordWithCode', {PARAM_PASSWORD: newPassword, PARAM_PASSWORD_CONFIRMATION: confirmNewPassword, PARAM_EMAIL: email, PARAM_CODE: code}, function (data) {
					changePasswordSuccess(changePasswordBox, data);
				});
			}


        });
    }

	function setupEnterHandler($form) {
		$form.find('input').each(function(i, val) {
			$(val).off('keypress').on('keypress', function(event) {
				if(event.which === 13) {
					event.preventDefault();
					$form.parent().find('.send-button').click();
				}
			});
		});
	}

    function checkDifferFrom(value, element, params) {
        return value !== params;
    }

    function checkEqualTo(value, element, params) {
        return value === params;
    }

    function notOnlyLetters(value) {
        return /[^a-zA-Z]/.test(value);
    }

    function addValidationCustomRules() {
        $.validator.addMethod('differFrom', checkDifferFrom);
        $.validator.addMethod('checkEqualTo', checkEqualTo);
        $.validator.addMethod('notOnlyLetters', notOnlyLetters);
    }

    function setupValidationConfiguration($form, userName) {

        addValidationCustomRules();

        var validationConfiguration = {
            errorClass: loginHelper.ERROR_CLASS,
            validClass: loginHelper.VALID_CLASS,
            rules: {
                PARAM_PASSWORD: {
                    required: true,
                    notOnlyLetters: true,
                    minlength: 6,
                    maxlength: 15,
                    differFrom: function () {
                        return userName;
                    }
                },
                PARAM_PASSWORD_CONFIRMATION: {
                    required: true,
                    checkEqualTo: function () {
                        return $form.find('#PARAM_PASSWORD').val();
                    }
                }
            },

            highlight: loginHelper.highlight,
            unhighlight: loginHelper.unHighlight,
            errorPlacement: loginHelper.errorPlacement
        };

        $form.validate(validationConfiguration);

    }

    function getFieldErrorMessage(data) {
        var message = '<ul>';
        var errorElementNameArray = data.ERROR_FIELDS.split(',');
        for (var i = 0; i < errorElementNameArray.length; i++) {
            var elementName = errorElementNameArray[i];
            message = message + '<li>' + data[elementName] + '</li>';
        }
        message = message + '<ul/>';
        return message;
    }

    function changePasswordSuccess(changePasswordBox, data) {
        var title;
        var message;
        var buttonText;

        // Response from UpdatePWValidation.java and UpdatePW.java
		if(data.RESULT === "OK") {
			title = data.HEADER;
			message = data.TEXT;
			buttonText = data.BUTTON_TEXT;
			// Inform the user that the password was updated. The player is after this logged in.
			loginHelper.showOneButtonPopup(changePasswordBox, title, message, buttonText, function () {
					var newPassword = changePasswordBox.$box.find('input[name=PARAM_PASSWORD]').filter(':visible').val();
					var user = changePasswordBox.model.email || changePasswordBox.model.tempPassLoginData.uName;
					changePasswordBox.$controller.boxes[0].$box.find('#usernameLoginBox').val(user);
					changePasswordBox.$controller.boxes[0].$box.find('#passwordLoginBox').val(newPassword);
					changePasswordBox.$controller.goToBox(changePasswordBox.$controller.boxes[0]);
					changePasswordBox.$controller.boxes[0].$box.find('#loginBoxButton').click();
					//$('#sliding-content-wrapper').find('.close').click();

			});
		} else {
			title = data.ERROR_HEADER;
			message = getFieldErrorMessage(data);
			buttonText = data.BUTTON_TEXT;
			loginHelper.showFailMessage(changePasswordBox, title, message, buttonText);
		}
    }

    var view = {
            render: function () {}
        },
        model = {
            userName: undefined,
            init: function (changePasswordBox) {
                init(changePasswordBox);
            },
            beforeRender: function (changePasswordBox) {
                var shouldVerifyPromise = comeon.promise.create();

                if (!changePasswordBox.model.shouldVerify) {
                    shouldVerifyPromise.resolve();
                } else {
                    shouldVerifyPromise.reject();
                }

                var $form = changePasswordBox.$box.find('form');
                setupValidationConfiguration($form, changePasswordBox.model.userName);

                var $elements = changePasswordBox.$box.find(':input');
                loginHelper.setupFocusPopover($elements);

                return [shouldVerifyPromise.promise()];
            },
            afterRender: function (changePasswordBox) {
            }
        };

    return {
        create: function ($box, $controller, tempPassLoginData) {
            var changePassBox = box.create($box, $controller, view, model);
			changePassBox.model.tempPassLoginData = tempPassLoginData;
			return changePassBox;
        },
        setCallback: function (doneCallback) {
            loginHelper.init(doneCallback);
        }
    };
});

